(function () {
    document.addEventListener("DOMContentLoaded", function() {
        var path = window.location.pathname;
        var isAccountPage = path.endsWith("/account") || path.endsWith("/account/");

        if (isAccountPage) {
            var customerAccountSection = document.querySelector(".medium-up--one-third");
            var locale = Shopify.locale || 'en';
            var customerId = window.ShopifyAnalytics.meta.page.customerId;

            if (customerAccountSection && customerId) {
                var deleteButton = createDeleteButton(locale);
                customerAccountSection.appendChild(deleteButton);
                setupModal(locale);
            }
        }
    });

    function createDeleteButton(locale) {
        var deleteButton = document.createElement("button");
        deleteButton.className = 'btn';
        deleteButton.innerHTML = locale === 'ar' ? "إغلاق الحساب" : "Close My Account";
        deleteButton.onclick = function () {
            showModal();
        };
        return deleteButton;
    }

    function setupModal(locale) {
        var modal = document.getElementById("deleteConfirmationModal");
        var modalText = document.getElementById("modalText");
        var confirmBtn = document.getElementById("confirmDelete");
        var cancelBtn = document.getElementById("cancelDelete");
        var closeBtn = document.querySelector(".close");

        modalText.innerHTML = locale === 'ar' ? "هل أنت متأكد من أنك تريد إغلاق و مسح حسابك؟ لا يمكن التراجع عن هذا الإجراء." : "Are you sure you want to close and delete your account? This action cannot be undone.";
        confirmDelete.innerHTML = locale === 'ar' ? "تأكيد" : "Confirm";
        cancelDelete.innerHTML = locale === 'ar' ? "إلغاء" : "Cancel";

        closeBtn.onclick = function() {
            modal.style.display = "none";
        };

        cancelBtn.onclick = function() {
            modal.style.display = "none";
        };

        confirmBtn.onclick = function() {
            modal.style.display = "none";
            deleteAccount();
        };

        window.onclick = function(event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        };
    }

    function showModal() {
        var modal = document.getElementById("deleteConfirmationModal");
        modal.style.display = "block";
    }

    function deleteAccount() {
        fetch("/apps/bayanatify/mashii", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ customerId: window.ShopifyAnalytics.meta.page.customerId }) 
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            if (data.status === "deleted" || data.status === "anonymized") {
                logoutUser();
            }
        }).catch(function(error) {
            console.error("Failed to send deletion request or handle the response: ", error);
        });
    }

    function logoutUser() {
        window.location.href = '/account/logout';
    }
})();
